import React from "react";

const Select = ({
  title,
  value,
  setValue,
  className = '',
  options,
  disable = false,
  required = false
}) => (
  <div className={className}>
    <label>{title} {required && <span style={{ color: 'red' }}>*</span>}</label>
    <select 
      className="form-select"
      value={value} 
      onChange={e => setValue(e.target.value)}
      disabled={disable}
    >
      {options.map(a => (
        <option key={a.id} value={a.id}>{a.nombre}</option>
      ))}
    </select>
  </div>
);

export default Select;